import * as Color from "color"
import PptxGenJS, { Slide } from "pptxgenjs"
import { Decomposition } from "../debt-table"
import * as DebtUtils from "../utils"
import { MasterSlide } from "../../pptx-configuration/master-slides"
import {
	Placeholder,
	getPlaceholderChartBodyOptions
} from "../../pptx-configuration/placeholders"
import { DocumentSection } from "../../types"
import { formatTitle } from "../../utils"
import { ReportConfiguration } from "../../../configuration"
import { LoanWithDecomposition } from "../../../../../model"

export function checkAnnuitySection(
	configuration: ReportConfiguration
): boolean {
	const annuity = configuration.debt.annuity
	return  annuity.tables
}

export function createAnnuitySection(
	pptx: PptxGenJS,
	configuration: ReportConfiguration,
	numbering: number[],
	childDecomposedLoans: any,
	years: number[],
	checked:string
): DocumentSection {
	const slides: Slide[] = []
	const slidesTitle = formatTitle("Annuités", numbering)
	const annuity = configuration.debt.annuity
	const placeholderBody = getPlaceholderChartBodyOptions()
	const baseColor = new Color(configuration.table.header.backgroundColor)

		DebtUtils.includeDebtTable(
			pptx,
			slidesTitle,
			"management-report-debt-annuity",
			Decomposition.Annuity,
			childDecomposedLoans,
			years,
			configuration,
			checked
		)

	return { slides, title: slidesTitle }
}


// WEBPACK FOOTER //
// ./src/component/management-report/generator/budgetGenerator/annuity-generator/index.tsx